import { useState, useEffect } from 'react'
import classnames from 'classnames'
import moment from 'moment/moment'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import Container from 'src/ui/molecules/Container'
import Table from 'src/ui/organisms/Table'

import CreateNotification from './CreateNotification'
import RemoveNotification from './RemoveNotification'
import useNotificationsApi from './useNotificationsApi'

const explorerUrl = 'https://etherscan.io'
const Notifications = () => {
  const [hasData, setHasData] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [hasRemainingQuota, setHasRemainingQuote] = useState(false)
  const [copiedAddress, setCopiedAddress] = useState('')

  const { getNotifications, getNotificationsQuota } = useNotificationsApi()

  const handleGetNotificationQuota = async () => {
    const quota = await getNotificationsQuota()
    setHasRemainingQuote(quota)
  }

  useEffect(() => {
    handleGetNotificationQuota()
  }, [])

  const columns = [
    {
      key: 'name',
      name: 'Name',
      render: (data: any) => data.name,
    },
    {
      key: 'createdAt',
      name: 'Created At',
      render: (data: any) => moment(data.createdAt).format('DD MMM YYYY'),
    },
    {
      key: 'tokenAddress',
      name: 'Token Address',
      width: '20%',
      render: (data: any) => (
        <div className="flex gap-1">
          <a
            target="_blank"
            className="text-main-blue"
            href={`${explorerUrl}/address/${data.tokenAddress}`}
            rel="noreferrer">
            {data.tokenAddress}
          </a>
          <CopyToClipboard
            text={data.tokenAddress}
            onCopy={() => setCopiedAddress(data.tokenAddress)}>
            <span
              className={classnames('icon-copy cursor-pointer text-sm text-light-gray', {
                'icon-tick !text-green': copiedAddress === data.tokenAddress,
              })}
            />
          </CopyToClipboard>
        </div>
      ),
    },
    {
      key: 'addressToWatch',
      name: 'Address To Watch',
      width: '20%',
      render: (data: any) => (
        <div className="flex gap-1">
          <a
            target="_blank"
            className="text-main-blue"
            href={`${explorerUrl}/address/${data.toOrFrom}`}
            rel="noreferrer">
            {data.toOrFrom}
          </a>
          <CopyToClipboard text={data.toOrFrom} onCopy={() => setCopiedAddress(data.toOrFrom)}>
            <span
              className={classnames('icon-copy cursor-pointer text-sm text-light-gray', {
                'icon-tick !text-green': copiedAddress === data.toOrFrom,
              })}
            />
          </CopyToClipboard>
        </div>
      ),
    },
    {
      key: 'hook',
      name: 'Hook',
      render: (data: any) => {
        return data.email || data.telegramChatId
      },
    },
    {
      key: 'actions',
      name: 'Actions',
      render: (data: any) => (
        <RemoveNotification id={data.id} onSuccess={() => setIsLoading(true)} />
      ),
    },
  ]

  return (
    <Container
      title="Notifications"
      empty={!hasData ? "You don't have any notifications created" : ''}
      action={hasRemainingQuota ? <CreateNotification onSuccess={() => setIsLoading(true)} /> : ''}>
      <Table
        columns={columns}
        itemsPerPage={10}
        loading={isLoading}
        fetchData={async (page: number) => {
          const events = (await getNotifications()) as []

          setHasData(events?.length ? true : false)

          const indexOfLastItem = page * 10
          const indexOfFirstItem = indexOfLastItem - 10

          setIsLoading(false)

          return {
            data: events?.slice(indexOfFirstItem, indexOfLastItem),
            totalCount: events?.length,
          }
        }}
      />
    </Container>
  )
}

export default Notifications
